<template>
  <autocomplete v-model="searchQuery" :options="options" :onItemSelected="onSearchItemSelected" :onInputChange="onInputChange" :required="required">
    <template #item="props">
      <company-card :company="props.item" with-tin :with-contact="false" :profile-picture="false" />
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  name: 'CompanyAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    preQuery: {
      type: String,
      default: ''
    },
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    includes: {
      type: Array,
      default: () => []
    },
    restrictTo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      }
    }
  },
  watch: {
    preQuery(val) {
      this.searchQuery = val || ''
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Company Name, Business Name or TIN')
    }
  },
  mounted () {
    this.searchQuery = this.preQuery || ''
  },
  methods: {
    onInputChange(query) {
      let params = {
        includes: this.includes,
        sort: [
          {
            key: 'name',
            direction: 'asc'
          },
          {
            key: 'id',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            or: true,
            filters: [
              ['name', 'ct', query.trim()],
              ['business_name', 'ct', query.trim()],
              ['tin', 'ct', query.trim()]
            ]
          }
        ]
      }

      if (Array.isArray(this.restrictTo) && this.restrictTo.length > 0) {
        params.filter_groups.push({
          filters: this.restrictTo
        })
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (query.trim().length >= this.minCharacter) {
        return new Promise(resolve => {
          this.$http.get(this.$appConfig.api.baseUrl + 'companies', {params: params})
            .then(response => {
              resolve(response.body.data)
            })
        })
      } else if (query.trim().length === 0) {
        this.$emit('selected', null)
      }
    },
    onSearchItemSelected(item) {
      this.searchQuery = item.external_id || item.name || item.id
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
